import React, { useState } from 'react';
import Select from "react-select";
import { FaEdit, FaTrash } from "react-icons/fa";
import { FaPlus } from "react-icons/fa6";
import LeaseApiService from '../../services/apiService';

const PreferenceDetails = ({ bedRooms, UnitClass, Properties, prefIntrest, UnitView, prefBuying, packageName, UnitTypeDesc, UnitModel, locationMaster, setPreferenceList, preferenceList }) => {
    const apiService = new LeaseApiService();

    const initialState = {
        interest: null,
        buying: null,
        location: null,
        community: null,
        project: null,
        unitNo: null,
        unitType: null,
        view: null,
        bedroom: null,
        budgetfrom: '',
        budgetTo: '',
        unitArea: '',
        unitClass: null,
        unitModel: null,
    };

    const [formData, setFormData] = useState(initialState);
    const [unitList, setUnitList] = useState([]);
    const [editIndex, setEditIndex] = useState(null);

    const handleInputChange = (e) => {
        const { name, value, files } = e.target;
        if (name === "file") {
            setFormData(prev => ({ ...prev, file: files[0] }));
        } else {
            setFormData(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleSelectChange = async (name, selected) => {
        if (name === "project") {
            setUnitList([])
            const params = new URLSearchParams();
            params.append('DropdownFor', 'CustUnitNoByPropertyNo');
            params.append('CascadValue', selected?.value);
            const res = await apiService.getApiParamater('CUSTOMER_CASCAD', `?${params.toString()}`);
            setFormData(prev => ({ ...prev, [name]: selected }));
            setUnitList(res?.data?.items)
        } else {
            setFormData(prev => ({ ...prev, [name]: selected }));
        }
    };

    const handleAddOrUpdate = () => {

        if (editIndex !== null) {
            const updated = [...preferenceList];
            updated[editIndex] = formData;
            setPreferenceList(updated);
            setEditIndex(null);
        } else {
            setPreferenceList(prev => [...prev, formData]);
        }

        setFormData(initialState);
    };

    const handleEdit = (index) => {
        setFormData({
            ...preferenceList[index],
            file: null, // file input cannot be prefilled
        });
        setEditIndex(index);
    };

    const handleDelete = (index) => {
        setPreferenceList(preferenceList.filter((_, i) => i !== index));
    };
    return (
        <div className="cost-center-section my-3">
            <div className="border-box2 p-3" style={{ borderRadius: '8px' }}>

                <div className="form-group grid-contain ">
                    <div className="d-flex">
                        <label className="form-label pt-1 start">Interest</label>
                        <Select
                            className="p-0 w-100"
                            menuPortalTarget={document.body}
                            options={prefIntrest?.map(country => ({ value: country?.value, label: country?.text }))}
                            value={formData.interest}
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            onChange={(selected) => handleSelectChange("interest", selected)}
                        />
                    </div>
                    <div className="d-flex">
                        <label className="form-label pt-1 start">Buying</label>
                        <Select
                            className="p-0 w-100"
                            menuPortalTarget={document.body}
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            options={prefBuying?.map(country => ({ value: country?.value, label: country?.text }))}
                            value={formData.buying}
                            onChange={(selected) => handleSelectChange("buying", selected)}
                        />
                    </div>
                    <div className="d-flex">
                        <label className="form-label pt-1 start">Location</label>
                        <Select
                            className="p-0 w-100"
                            menuPortalTarget={document.body}
                            options={locationMaster?.map(country => ({ value: country?.value, label: country?.text }))}
                            value={formData.location}
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            onChange={(selected) => handleSelectChange("location", selected)}
                        />
                    </div>
                    <div className="d-flex">
                        <label className="form-label pt-1 start">Property</label>
                        <Select
                            className="p-0 w-100"
                            menuPortalTarget={document.body}
                            options={packageName?.map(country => ({ value: country?.value, label: country?.text }))}
                            value={formData.project}
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            onChange={(selected) => handleSelectChange("project", selected)}
                        />
                    </div>
                    <div className="d-flex">
                        <label className="form-label pt-1 start">Unit No</label>
                        <Select
                            className="p-0 w-100"
                            menuPortalTarget={document.body}
                            options={unitList?.slice()?.sort((a, b) => a.text.localeCompare(b.text, undefined, { numeric: true, sensitivity: 'base' }))?.map(country => ({ value: country?.value, label: country?.text }))}
                            value={formData.unitNo}
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            onChange={(selected) => handleSelectChange("unitNo", selected)}
                        />
                    </div>
                    <div className="d-flex">
                        <label className="form-label pt-1 start">Unit Type</label>
                        <Select
                            className="p-0 w-100"
                            menuPortalTarget={document.body}
                            options={UnitTypeDesc?.map(country => ({ value: country?.value, label: country?.text }))}
                            value={formData.unitType}
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            onChange={(selected) => handleSelectChange("unitType", selected)}
                        />
                    </div>
                    <div className="d-flex">
                        <label className="form-label pt-1 start">View</label>
                        <Select
                            className="p-0 w-100"
                            menuPortalTarget={document.body}
                            options={UnitView?.map(country => ({ value: country?.value, label: country?.text }))}
                            value={formData.view}
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            onChange={(selected) => handleSelectChange("view", selected)}
                        />
                    </div>
                    <div className="d-flex">
                        <label className="form-label pt-1 start">Bedrooms</label>
                        <Select
                            className="p-0 w-100"
                            menuPortalTarget={document.body}
                            options={bedRooms?.map(country => ({ value: country?.value, label: country?.text }))}
                            value={formData.bedroom}
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            onChange={(selected) => handleSelectChange("bedroom", selected)}
                        />
                    </div>
                    <div className="d-flex">
                        <label className="form-label pt-1 start">Unit Class</label>
                        <Select
                            className="p-0 w-100"
                            menuPortalTarget={document.body}
                            options={UnitClass?.map(country => ({ value: country?.value, label: country?.text }))}
                            value={formData.unitClass}
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            onChange={(selected) => handleSelectChange("unitClass", selected)}
                        />
                    </div>
                    <div className="d-flex">
                        <label className="form-label pt-1 start">Unit Model</label>
                        <Select
                            className="p-0 w-100"
                            menuPortalTarget={document.body}
                            options={UnitModel?.map(country => ({ value: country?.value, label: country?.text }))}
                            value={formData.unitModel}
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            onChange={(selected) => handleSelectChange("unitModel", selected)}
                        />
                    </div>
                    <div className="d-flex">
                        <label className="form-label pt-1 start">Budgrt From</label>
                        <input
                            type="number"
                            className="p-2 form-control w-75"
                            name="budgetfrom"
                            value={formData.budgetfrom}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className="d-flex">
                        <label className="form-label pt-1 start">Budget To</label>
                        <input
                            type="number"
                            className="p-2 form-control w-75"
                            name="budgetTo"
                            value={formData.budgetTo}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className="d-flex">
                        <label className="form-label pt-1 start">Unit Area (approx)</label>
                        <input
                            type="text"
                            className="p-2 form-control w-75"
                            name="unitArea"
                            value={formData.unitArea}
                            onChange={handleInputChange}
                        />
                    </div>
                </div>
                <div className='my-4'>
                    <div className='mainbtnSecondary flex-end gap-2 col-2' onClick={handleAddOrUpdate}>
                        <FaPlus color='#fff' className='center mt-1 mx-2' />
                        <div className='center'>
                            {editIndex !== null ? "Update Preference" : "Add Preference"}
                        </div>
                    </div>
                </div>
                <div className='table-container' style={{ overflowX: 'auto', height: "400px" }}>
                    <table className='table table-bordered gridshad'>
                        <thead className='dynoTable'>
                            <tr>
                                <th>Action</th>
                                <th>Interest</th>
                                <th>Bedrooms</th>
                                <th>Unit Area	</th>
                                <th>Unit Model	</th>
                                <th>Location</th>
                                <th>Project</th>
                                <th>Unit</th>
                                <th>Unit View	</th>
                                <th>Floor</th>
                                <th>Budget From	</th>
                                <th>Budget To	</th>
                            </tr>
                        </thead>
                        <tbody>
                            {preferenceList.map((data, index) => (
                                <tr key={index}>
                                    <td className="text-center d-flex gap-3">
                                        <FaEdit size={20} onClick={() => handleEdit(index)} />
                                        <FaTrash size={20} color="red" onClick={() => handleDelete(index)} />
                                    </td>
                                    <td>{data.interest?.label}</td>
                                    <td>{data.bedroom?.label}</td>
                                    <td>{data.unitArea}</td>
                                    <td>{data.unitType?.label}</td>
                                    <td>{data.location?.label}</td>
                                    <td>{data.project?.label}</td>
                                    <td>{data.unitNo?.label}</td>
                                    <td>{data.view?.label}</td>
                                    <td>{data.Remarks}</td>
                                    <td>{data.budgetfrom}</td>
                                    <td>{data.budgetTo}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default PreferenceDetails;
